import manifest from './manifest.json';
import p1 from './posts/2025-october-market-update.md?raw';
import p9 from './posts/august-2026-housing-market-insights.md?raw';
import p2 from './posts/insurance-in-the-mortgage-process.md?raw';
import p3 from './posts/Market-Update-Veterans-Day.md?raw';
import p4 from './posts/questions-to-ask-about-a-mortgage.md?raw';
import p7 from './posts/the-2026-pivot.md?raw';
import p10 from './posts/unbeatable-loans-platform-updates-october-2026.md?raw';
import p8 from './posts/weekly-housing-market-briefing-april-2026.md?raw';
import p5 from './posts/what-to-put-in-a-lease.md?raw';
import p6 from './posts/where-mortgage-rates-come-from.md?raw';

const bodies: Record<string, string> = {
  'unbeatable-loans-platform-updates-october-2026': p10,
  'august-2026-housing-market-insights': p9,
  'weekly-housing-market-briefing-april-2026': p8,
  'the-2026-pivot': p7,
  'questions-to-ask-about-a-mortgage': p4,
  'Market-Update-Veterans-Day': p3,
  '2025-october-market-update': p1,
  'insurance-in-the-mortgage-process': p2,
  'what-to-put-in-a-lease': p5,
  'where-mortgage-rates-come-from': p6,
};

export type BlogAuthor = {
  name: string;
  role: string;
};

export type BlogPostMeta = {
  slug: string;
  title: string;
  description: string;
  category: string;
  publishedAt: string;
  readTimeMinutes: number;
  author: BlogAuthor;
  image?: string;
  imageAlt?: string;
};

export function getBlogManifest(): { posts: BlogPostMeta[] } {
  return manifest as { posts: BlogPostMeta[] };
}

export function getPostBody(slug: string): string | undefined {
  return bodies[slug];
}

export function getPostBySlug(slug: string): BlogPostMeta | undefined {
  return getBlogManifest().posts.find((p) => p.slug === slug);
}
